import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-signup-payment-failed',
  templateUrl: './signup-payment-failed.component.html',
  styleUrls: ['./signup-payment-failed.component.scss']
})
export class SignupPaymentFailedComponent implements OnInit {
/* --------------------------------- FIELDS -------------------------------- */
  /* ------------------------------- CONSTRUCTOR ------------------------------ */
  constructor(
    private _dialogRef: MatDialogRef<SignupPaymentFailedComponent>,
    @Inject(MAT_DIALOG_DATA) public data: null,
  ) { }
  /* ----------------------------- NG-LIFE-CYCLES ----------------------------- */
  ngOnInit() {
  }
  /* ------------------------------ CUSTOM-METHODS ----------------------------- */
  dialogClose() {
    // this._dialogRef.close();
    document.getElementsByClassName("animate__animated")[0].classList.remove("animate__fadeInDown")
    document.getElementsByClassName("animate__animated")[0].classList.add("animate__fadeOutUp"); 
    setTimeout(() => { this._dialogRef.close(); }, 1000);
  }
  /* --------------------------------- GETTERS --------------------------------- */

}
